export default "__VITE_ASSET__C7Y2FZF4__"